// custom typefaces
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import '@fontsource/montserrat/900.css';
import '@fontsource/merriweather/400.css';
import '@fontsource/merriweather/400-italic.css';
import '@fontsource/merriweather/700.css';

// normalize CSS across browsers
import './src/normalize.css';

// Highlighting for code blocks (must be before custom styles so we can override)
import 'prismjs/themes/prism.css';

// custom CSS styles (loaded last to override PrismJS theme)
import './src/style.css';

// Accessibility: Make scrollable code blocks keyboard accessible
export const onRouteUpdate = () => {
    // Add tabindex to all pre elements in code highlights so they can be keyboard navigated
    const codeBlocks = document.querySelectorAll('.gatsby-highlight pre');
    codeBlocks.forEach((block) => {
        if (!block.hasAttribute('tabindex')) {
            block.setAttribute('tabindex', '0');
        }
    });
};
